/* unplugin-vue-components disabled */import { render } from "./TotalSummaries.vue?vue&type=template&id=7ff5f541&scoped=true&ts=true"
import script from "./TotalSummaries.vue?vue&type=script&lang=ts"
export * from "./TotalSummaries.vue?vue&type=script&lang=ts"

import "./TotalSummaries.vue?vue&type=style&index=0&id=7ff5f541&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff5f541"]])

export default __exports__